import React from "react";
export default function HCR_Greater_Than() {
  return <div>Excel_Highlight_Cell_Rules</div>;
}
